import { useEffect } from "react";
import { Link } from "react-router-dom";
import { endPoints, siteConfig } from "../../../config/end-points";
import { FiArrowLeft } from "react-icons/fi";
import "../legal.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = `${endPoints.title} | Privacy Policy`;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/login" className="legal-back">
          <FiArrowLeft size={16} /> Back to Login
        </Link>

        <div className="legal-header">
          <img src={endPoints.logo} alt={endPoints.title} className="legal-logo" />
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: March 18, 2026</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Information We Collect</h2>
            <p>We collect the following types of information when you use {siteConfig.title}:</p>
            <ul>
              <li><strong>Account Information:</strong> Name, email address, and login credentials when you create an account</li>
              <li><strong>Usage Data:</strong> Information about how you interact with the Platform, including pages visited and features used</li>
              <li><strong>Content Data:</strong> Websites, pages, and content you create using the Platform</li>
              <li><strong>Device Information:</strong> IP address, browser type, and device identifiers for security and service improvement</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide, maintain, and improve the Platform</li>
              <li>Process your requests and manage your account</li>
              <li>Send important service-related communications</li>
              <li>Protect against fraud and unauthorized access</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Data Storage and Security</h2>
            <p>
              We implement industry-standard security measures to protect your personal information.
              Your data is stored on secure servers, and we use encryption for data transmission.
              However, no method of electronic storage is 100% secure, and we cannot guarantee
              absolute security.
            </p>
          </section>

          <section>
            <h2>4. Third-Party Services</h2>
            <p>
              The Platform may integrate with third-party services such as AI providers, email
              services, and analytics tools. These services have their own privacy policies, and
              we encourage you to review them. We only share the minimum data necessary for these
              integrations to function.
            </p>
          </section>

          <section>
            <h2>5. Cookies</h2>
            <p>
              We use cookies and similar technologies to maintain your session, remember your
              preferences, and improve your experience. You can control cookie settings through
              your browser preferences.
            </p>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We retain your personal information for as long as your account is active or as
              needed to provide services. If you delete your account, we will remove your personal
              data within a reasonable timeframe, except where required by law.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your account and associated data</li>
              <li>Object to processing of your personal information</li>
              <li>Export your data in a portable format</li>
            </ul>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              The Platform is not intended for use by individuals under the age of 16. We do not
              knowingly collect personal information from children. If we become aware that a child
              has provided us with personal information, we will take steps to delete such data.
            </p>
          </section>

          <section>
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any
              material changes by posting the updated policy on the Platform. Your continued use
              of the Platform constitutes acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our data practices, please
              contact us through the Platform's support channels.
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <p>{siteConfig.copyright}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
